import styled from 'styled-components';

export const MessageContainer: any = styled.div`
  background-color: ${(props: any) =>
    props.isHighlight ? '#fdf6df' : '#f2f5fc'};
  padding: 12px;
`;

export const MessageContent = styled.div`
  position: relative;
  border-radius: 4px;
  background-color: #ffffff;
  display: inline-block;
  max-width: 270px;
  border: solid 1px ${(props) => (props.defaultChecked ? '#0076ea' : '#cccccc')};
`;

export const TextMessage = styled.div`
  font-size: 14px;
  font-weight: 500;
  min-width: 48px;
  color: #333333;
  padding: 12px;
`;

export const PopupImage = styled.img`
  position: block;
  margin: auto;
`;

export const DeletedMessageContainer = styled.div`
  display: inline-block;
`;
export const DeletedSeparate = styled.div`
  width: 144px;
  height: 1px;
  background-color: #cccccc;
  top: 10px;
  position: relative;
  float: left;
`;

export const DeleteMessage = styled.div`
  padding-left: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  float: right;
`;
